<template>
  <div class="setup-wizard">
    <div class="setup-wizard__header-step">
      <span class="setup-wizard__header-step-title">Create Mandate</span>
    </div>
    <div class="setup-wizard__body setup-wizard__body--full">
      <div class="setup-wizard__content setup-wizard__content--full">
        <v-form ref="passwordForm" lazy-validation>
          <v-text-field
            light
            class="setup-wizard__form-item"
            v-model="model.mandate.name"
            readonly
            :label="$t('USER-LABEL-MANDATE-NAME')"
            :rules="[rules.required, rules.name]"
          >
          </v-text-field>
          <v-text-field
            light
            class="setup-wizard__form-item"
            v-model="model.warehouse.name"
            :label="$t('USER-LABEL-WAREHOUSE-NAME')"
            :rules="[rules.required, rules.name]"
          >
          </v-text-field>

          
        
        </v-form>
      </div>
      <div class="setup-wizard__actions">
        <div class="setup-wizard__actions-wrapper">
          <v-btn rounded elevation="0" light small class="setup-wizard__btn--cancel" @click="cancel">Cancel</v-btn>
          <v-btn rounded elevation="0" light :disabled="!canGoNext" small class="setup-wizard__btn" @click="next">Next</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  name: "SetupWizardStep4",
  components: {
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: null,
      canGoNext: false,
      unitSystems: [
        {
          text: "metrisch",
          value: "metric",
        },
        {
          text: "imperial",
          value: "imperial",
        },
      ],
    };
  },
  computed: {
    languages() {
      let languages = [
        {
          id: 1,
          name: this.$t("GLOBAL-LANG-DE"),
          shortcode: "de",
        },
        {
          id: 2,
          name: this.$t("GLOBAL-LANG-EN"),
          shortcode: "en",
        },
        {
          id: 3,
          name: this.$t("GLOBAL-LANG-ES"),
          shortcode: "es",
        },
      ];
      return languages;
    },
   
  },
  updated() {
    this.canGoNext = this.$refs.passwordForm.validate();
  },
  created() {
    this.model = cloneDeep(this.data);
  },
  methods: {
    next() {
      this.$emit("next", cloneDeep(this.model));
    },
    cancel(){
      this.$emit('cancel');
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
